import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'

const TokenKey = 'token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  Cookies.set(TokenKey, token)
  // let sub = JSON.parse(Base64.decode(token))
  // let sub = JSON.parse(Base64.decode(token.split('.')[1]))
  let sub=eval('(' + Base64.decode(token.split(".")[1]) + ')');

  Cookies.set("92929292929292929229992929292929", sub)
  Cookies.set('NICKNAME', sub.nickName)
  Cookies.set('ROLEID', sub.roleId)
  Cookies.set('ROLECODE', sub.roleCode)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getNickName () {
  console.log(Cookies.get('NICKNAME'))
  return Cookies.get('NICKNAME')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js